const $ = window.jQuery

// import { initBarba, goBarba } from './modules/barba_setup'

// https://getbootstrap.com/docs/5.3/getting-started/javascript/
// require('bootstrap/js/dist/modal.js')
// import ScrollSpy from 'bootstrap/js/dist/scrollspy'
import Modal from 'bootstrap/js/dist/modal'

import appUtils from './modules/app_utils'

import toc from './tableofcontent'

import { debounce, forEach, throttle  } from 'lodash';
import inlineNotice from './modules/inline_notice';
import mainNavigation from './modules/main_navigation';
// import mainNavigationMobile from './modules/main_navigation_mobile';

import svgInline from './modules/svg_inline'

import modalFetch from './modules/modal_fetch'

import inView from './modules/in_view';

import hscroll from './modules/hscroll';

import slickEvents from './modules/slick_events';

import layout from './modules/layout';

// import baguetteBox from 'baguettebox.js';
// import FsLightbox from 'fslightbox' // require("fslightbox")
import lightbox from './modules/lightbox';

import getwidTabs from './modules/getwid_tabs.js'

let currentScroll = 0
const windowScroll = function(){
  appUtils.$html.removeClass('toc-sticky-expanded')

  const scrollPos = appUtils.$window.scrollTop()
  if(scrollPos < 30) {
    appUtils.$body.removeClass('is-scrolled')
  } else {
    appUtils.$body.addClass('is-scrolled')
  }
  if (scrollPos > currentScroll) {
    appUtils.$body.removeClass('is-scrolled-up')
  } else if (scrollPos < currentScroll) {
    appUtils.$body.addClass('is-scrolled-up')
  }
  currentScroll = scrollPos
  /*
  if (Math.abs(currentScroll - ScrollTrigger.maxScroll(window)) < 10) {
    // footer animation
    appUtils.triggerEvent('bg-footer')
  }
  */
}

const resizeHandler = function() {
  // scrollMax = document.documentElement.scrollHeight - document.documentElement.clientHeight
  windowScroll()
  document.documentElement.style.setProperty('--vh', window.innerHeight * 0.01 + 'px')

  layout.setMetadataOffset()
  
}
const resizeHandlerThrottle = throttle(resizeHandler, 400, {
  'leading': true,
  'trailing': true
})
const windowScrollThrottle = throttle(windowScroll, 400, {
  'leading': true,
  'trailing': false
})


const onDocumentReady = function() {
  appUtils.$document
    .on('click', '[data-toggle-class]', function(e){
      // e.preventDefault()
      $('html').toggleClass($(this).attr('data-toggle-class'))
    })
    .on('click', '[data-c24-toggle="collapse"]', function(e){
      e.preventDefault()
      $(this).data('collapsed', !$(this).data('collapsed'))
      if ($(this).data('collapsed')) {
        $($(this).attr('href')).hide();
        $(this).text($(this).data('c24-open-label'))
      } else {
        $($(this).attr('href')).show();
        $(this).text($(this).data('c24-close-label'))
      }
    })
    .on('click', '.tribe-common-form-control-text-reset', function(){
      const searchform = $('.tribe-events-c-events-bar__search-form')
      if (searchform.length) {
        $('.tribe-common-form-control-text__input').val('')
        searchform.submit()
      }
    })
    /*
    To avoid Trive keyword.php template override, Add reset button on ajaxComplete
    $( document ).on( "ajaxComplete", function() {
      $( ".log" ).text( "Triggered ajaxComplete handler." );
    } );
    */

  slickEvents.appInit()
  hscroll.appInit()

  resizeHandler()
    appUtils.$window
			.resize(resizeHandlerThrottle)
			.scroll(windowScrollThrottle)
  
  /*
  * Barba not enabled
  */
  // initBarba(barbaPageViewInit, barbaPageViewDestroy, barbaHooksAfter, barbaHooksBefore, barbaPageViewBefore)
  barbaPageViewInit()
}

const barbaPageViewDestroy = function(barbaCurrentContainer){
  // mainNavigation.destroy()
  inlineNotice.destroy()
  svgInline.destroy()
  modalFetch.destroy()
  hscroll.destroy()
  inView.destroy()
  slickEvents.destroy()
}

// beforeEnter transition
const barbaPageViewBefore = function(data) {
  // init before transiton to prevent flickering
  // --mainNavigation.init()
}

// afterEnter transition
const barbaPageViewInit = function(barbaCurrentContainer){
  $('.wpml-ls-statics-shortcode_actions').attr('data-barba-prevent', 'all') // disable barba on langswitch menu

  hscroll.init() // on barbaPageViewBefore would break barba transition
  // mainNavigation.init()
  
  // mainNavigationMobile.init()
  inlineNotice.init()
  // vueApp.init()
  svgInline.init()
  modalFetch.init()
  inView.init()
  slickEvents.init()

  layout.setMetadataOffset()

  // baguetteBox.run('.wp-block-getwid-images-slider__wrapper');
  // const lightbox = new FsLightbox();
  // refreshFsLightbox();

  lightbox.init()
  

  /*
  * External link: target _blank
  */
  // https://css-tricks.com/snippets/jquery/target-only-external-links/
  $('a:not([target="_blank"])').filter(function() {
    return this.hostname && this.hostname !== location.hostname;
  }).attr('target', '_blank');

  // $('.simpletoc-list').wrap('<div class="document-contents-wrapper alignfull">')
  // https://getbootstrap.com/docs/5.2/components/scrollspy/
  const TABLE_OF_CONTENTS_SELECTOR = '.simpletoc-list'
  if ($(TABLE_OF_CONTENTS_SELECTOR).length) {
    // const scrollSpy = new ScrollSpy($('html'), {
    //   target: TABLE_OF_CONTENTS_SELECTOR
    // })
    
    $(TABLE_OF_CONTENTS_SELECTOR).attr('data-toc', '')
    // $(TABLE_OF_CONTENTS_SELECTOR).find('ul, ol').wrap('<div class="document-contents-wrapper">')
    $(TABLE_OF_CONTENTS_SELECTOR).wrap('<div class="document-contents-wrapper alignwide">')
    
    $('.wp-site-blocks header.wp-block-template-part').attr('data-toc-sticky-wrapper', '')
    $(TABLE_OF_CONTENTS_SELECTOR).find('li').each(function() {
      $(this).attr('data-toc-item', '')
      let $a = $(this).find('a')
      // $(this).attr('data-remove-class', 'toc-sticky-expanded') (( not working with scroll-behaviour smooth))
      let href = $a.attr('href')
      $(this).attr('id', 'li-' + href.substring(1))
      $(href).attr('data-toc-heading', '')
    })
    $('html').addClass('has-toc')
    toc.init()
  }
  

  $('[data-c24-toggle="collapse"]').each(function(item, index){
    $($(this).attr('href')).hide();
    $(this).data('collapsed', 1)
    $(this).data('c24-open-label', $(this).text())
  })

  getwidTabs.init()

  
  if (appUtils.isMd()) {
    $('.is-c24-odd-shift').each(function(index, item){
      const _this = $(this)
      _this.prepend('<div class="container-odd"></div>')
      _this.prepend('<div class="container-even"></div>')
      const _containerOdd = _this.find('.container-odd')
      const _containerEven = _this.find('.container-even')
      _this.find('> .wp-block-group, > .wp-block-post').each(function(index) {
        if ((index + 1) % 2 === 0) {
          _containerOdd.append($(this));     // indice pari
        } else {
          _containerEven.append($(this));  // indice dispari
        }
      });
    })
  }


  /*
  * Getwid counter starts on window scroll (waypoints)
  * not working on modal scroll; as a fix, in modal, set counter to its final value or trigger the counter immediatelly
  */
  // https://wordpress.org/support/topic/initialise-getwid-blocks-after-appending-post-to-document/
  // Getwid Blocks initialization!
  document.body.dispatchEvent(new Event('post-load') ) // same as $(document.body).trigger('post-load')
}


const adminbarSetAttributes = function() {
  let adminBar = document.querySelector('#wpadminbar');
  if(adminBar){
    document.querySelector('#wpadminbar').setAttribute('data-barba-prevent', 'all')
    document.querySelector('#wpadminbar').setAttribute('data-scroll', 'all')
    document.querySelector('#wpadminbar').setAttribute('data-scroll-sticky', '')
    document.querySelector('#wpadminbar').setAttribute('data-scroll-target', '#barba-wrapper')
  }
}

adminbarSetAttributes()

const barbaHooksAfter = function(data) {
  adminbarSetAttributes()
}

const barbaHooksBefore = function(data) {

}

const onWindowLoad = function() {
  layout.setMetadataOffset()
}

appUtils.$document.on('ready', onDocumentReady)
appUtils.$window.on('load', onWindowLoad);

